import { orZero } from './utils';

const AAC_SAMPLING_RATES_LUT = [
  96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000
];

export interface Mp4aConfig {
  profileIdc: number,
  sampleRate: number,
  numberOfChannels: number,
}

export function parseMp4AudioConfig(data: Uint8Array): Mp4aConfig {
  if(orZero(data.byteLength) < 2) {
    throw new Error(`Unsufficient MP4A config length: ${data}`)
  }

  const profileIdc = (data[0] & 0xf8) >> 3;

  const sampleRateIdc = ((data[0] & 0x07) << 1) + (((data[1] & 0x80) >> 7));
  if(0 > sampleRateIdc || AAC_SAMPLING_RATES_LUT.length <= sampleRateIdc) {
    throw new Error(`Invalid AAC config: sampleRateIdc = ${sampleRateIdc}`);
  }

  const numberOfChannels = (data[1] & 0x78) >> 3;
  if (0 >= numberOfChannels) {
    throw new Error(`Invalid AAC config: numberOfChannels = ${numberOfChannels}`);
  }

  return {
    profileIdc,
    sampleRate: AAC_SAMPLING_RATES_LUT[sampleRateIdc],
    numberOfChannels,
  }
}
